/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
// import GridContainer from "@insite/mobius/GridContainer"; // Store Custom Code
// import GridItem from "@insite/mobius/GridItem"; // Store Custom Code
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
// import Link from "@insite/mobius/Link"; // Store Custom Code
// import Typography from "@insite/mobius/Typography"; // Store Custom Code
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { TYPOGRAPHY } from "@store/theme/common/design";
/* Store Custom Code - End */

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

/* Store Custom Code - Start */
export interface CardListHeadingStyles {
    wrapper?: GridItemProps;
    container?: GridContainerProps;
    typography?: TypographyPresentationProps;
    link?: LinkPresentationProps;
}

export const cardListHeadingStyle: CardListHeadingStyles = {
    wrapper: {
        width: 12,
        css: css`
            margin-bottom: 20px !important;
        `,
    },
    container: {
        gap: 0,
    },
    typography: {
        variant: "h2",
    },
    link: {
        icon: {
            iconProps: {
                src: ChevronRight,
                size: 20,
            },
            position: "right",
        },
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
            underline: true,
        },
        css: css`
            margin-left: auto;
        `,
    },
};

const styles = cardListHeadingStyle;
/* Store Custom Code - End */

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        <GridItem {...styles.wrapper} /* Store Custom Code */>
            <GridContainer {...styles.container} /* Store Custom Code */>
                <GridItem width={8}>
                    <Typography className="card-list-heading" {...styles.typography} /* Store Custom Code */>
                        {heading}
                    </Typography>
                </GridItem>
                {viewAllUrl && (
                    <GridItem width={4}>
                        <Link
                            href={viewAllUrl}
                            /* Store Moved Code - icon */
                            /* Store Moved Code - typographyProps */
                            /* Store Moved Code - css */
                            className="view-all-link"
                            data-test-selector="cardListHeadingViewAllLink"
                            // Store Custom Code
                            {...styles.link}
                        >
                            {translate("View All")}
                            <VisuallyHidden>
                                {translate("View All")} {heading}
                            </VisuallyHidden>
                        </Link>
                    </GridItem>
                )}
            </GridContainer>
        </GridItem>
    );
};

export default CardListHeading;
